export default "__VITE_ASSET__B9wUgoW9__"